// Link para o card da oportunidade no GHL white-label da Orbion.
const GHL_APP_BASE = 'https://painel.orbioncompany.com.br/v2/location/cpQfo8ZEFDJpB2f51Doo';

// Só há card no GHL para oportunidades REAIS; leads desk_legacy usam id "legacy:*" (sem card).
// Formato que ABRE o modal do card (não só o pipeline/kanban): id no path + ?tab=OpportunityDetails.
export const ghlOppUrl = (oppId) =>
    oppId && !String(oppId).startsWith('legacy:')
        ? `${GHL_APP_BASE}/opportunities/list/${oppId}?tab=OpportunityDetails`
        : null;

// Link para o card do CONTATO no GHL — usado quando o evento não tem oportunidade
// (ex.: números coletados de "pegou contato", que existem como contato mas não como opp).
export const ghlContactUrl = (contactId) =>
    contactId ? `${GHL_APP_BASE}/contacts/detail/${contactId}` : null;
